"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var font_1 = require("@headspace/hs-web-style-guide/dist/font");

var flex = require('@headspace/hs-web-style-guide/dist/flex').default;

var wrapperStyles = hs_web_style_guide_1.css(flex.flex, flex.row, flex.justifyContentSpaceBetween, flex.alignItemsCenter, {
  width: '100%',
  color: colors_1.white,
  backgroundColor: colors_1.comet,
  padding: '18px 24px',
  borderRadius: 5,
  boxSizing: 'border-box'
});
var titleStyles = hs_web_style_guide_1.css(font_1.bold, {
  fontSize: 16
});

function ActionBar(props) {
  return React.createElement("div", __assign({}, wrapperStyles, props), React.createElement("div", __assign({}, titleStyles), props.title), React.createElement("div", null, props.children));
}

exports.ActionBar = ActionBar;
var buttonStyles = hs_web_style_guide_1.css(font_1.bold, {
  color: colors_1.white,
  padding: 0,
  marginLeft: 32,
  border: 'none',
  fontSize: 12,
  backgroundColor: 'transparent',
  cursor: 'pointer'
});

function ActionBarButton(props) {
  return React.createElement("button", __assign({}, buttonStyles, props), props.children);
}

exports.ActionBarButton = ActionBarButton;